// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"17c12095","453":"87c69207","591":"a6c9517e"}[chunkId] + ".chunk.js";
};